import { render, staticRenderFns } from "./TrashThinIcon.vue?vue&type=template&id=de33e2e4"
import script from "./TrashThinIcon.vue?vue&type=script&lang=js"
export * from "./TrashThinIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports